import axios from 'axios';
import { initializeApp } from 'firebase/app';
import { isSupported } from 'firebase/messaging';
import { getHeadersForRequest } from './utils/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

// Request permission & get FCM token (let SDK handle SW registration)
export const requestPermission = async () => {
  if (!(await isSupported())) {
    console.warn('🚫 This browser does not support push notifications.');
    alert('🚫 This browser does not support push notifications.');
    return null;
  }

  try {
    const { getMessaging, getToken } = await import('firebase/messaging');
    const messaging = getMessaging(app);

    // SDK will auto-register the SW under firebase-cloud-messaging-push-scope
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (!token) {
      console.warn('⚠️ No FCM token received.');
      alert('⚠️ No FCM token received.');
      return null;
    }

    // 1) Try the new client hints API
    let deviceModel = 'unknown';
    if (
      // @ts-ignore
      navigator.userAgentData?.getHighEntropyValues
    ) {
      try {
        // @ts-ignore
        const hints = await navigator.userAgentData.getHighEntropyValues([
          'model',
        ]);
        deviceModel = hints.model || 'unknown';
      } catch {
        // if it fails, we’ll drop through to the fallback
      }
    }
  
    // 2) Fallback for older browsers
    if (deviceModel === 'unknown') {
      deviceModel =
        // e.g. "Mozilla/5.0 (Linux; Android 9; Pixel 3 Build/PPR1.180610.009)"
        navigator.userAgent;
    }
  
    console.log(deviceModel);

    const headers = await getHeadersForRequest();
    const savedToken = localStorage.getItem('fcmToken');

    if (token !== savedToken) {
      await axios.post(
        `${process.env.REACT_APP_TEST_API_URL}/notifications/save-token`,
        { token, device : deviceModel },
        { headers }
      );
      localStorage.setItem('fcmToken', token);
      console.log('✅ FCM token saved:', token);
      alert('✅ FCM token saved:', token);
    } else {
      console.log('✅ Token already saved, no need to re-save.');
      alert('✅ Token already saved, no need to re-save.');
    }

    return token;
  } catch (err) {
    console.error('🔥 Error getting FCM token:', err);
    alert('🔥 Error getting FCM token:', err);
    return null;
  }
};

// Foreground message listener
export const onMessageListener = async () => {
  if (!(await isSupported())) {
    console.warn('🚫 This browser does not support push notifications.');
    return;
  }

  const { getMessaging, onMessage } = await import('firebase/messaging');
  const messaging = getMessaging(app);

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};
